import React, { memo } from "react";
import StyledOutlineButton from "../Classroom/StyledOutlineButton";
import { Container } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import {
  getClassroomIdFromStoredUrl,
  getStudentRedirectUrl,
} from "../../utils/redirectStorage";
import LazyLoad from "react-lazyload";
import "./styles.scss"; // Make sure to import your styles

function BeforeLoginHeader({ children, isLogin }) {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const liveclassid = queryParams.get("liveclassid");
  const classroomId = queryParams.get("classroomId");
  const redirectUrl = queryParams.get("redirect"); // Get the redirect URL if available

  const handleButtonClick = () => {
    const params = new URLSearchParams();

    if (liveclassid) {
      params.append("liveclassid", liveclassid);
    }

    // Use classroomId from URL params or extract from stored redirect URL
    let finalClassroomId = classroomId;
    if (!finalClassroomId && isLogin) {
      // When going from login to register, try to get classroomId from stored URL
      finalClassroomId = getClassroomIdFromStoredUrl();
    }

    if (finalClassroomId) {
      params.append("classroomId", finalClassroomId);
    }

    if (redirectUrl) {
      params.append("redirect", redirectUrl); // Append the redirect URL if it exists
    } else {
      const storedRedirectUrl = getStudentRedirectUrl();
      if (storedRedirectUrl) {
        const redirectValue = storedRedirectUrl.startsWith("/")
          ? storedRedirectUrl.slice(1)
          : storedRedirectUrl;
        params.append("redirect", redirectValue);
      }
    }

    const targetUrl = isLogin
      ? `/register?${params.toString()}`
      : `/login?${params.toString()}`;

    navigate(targetUrl); // Navigate with the parameters
  };

  return (
    <div className="before-login-wrapper">
      <Container className="before-login-header d-flex justify-content-between align-items-center py-2">
        <LazyLoad height={20} offset={100}>
          <img src="/Logo.png" alt="Logo" className="header-logo" />
        </LazyLoad>
        <div className="header-content d-flex gap-2 align-items-center">
          <label className="header-label">
            {isLogin ? "Don't have an account?" : "Already have an account?"}
          </label>
          <StyledOutlineButton
            btnText={isLogin ? "Create Account" : "Sign In"}
            onClick={handleButtonClick}
          />
        </div>
      </Container>
      <div>{children}</div>
    </div>
  );
}

export default memo(BeforeLoginHeader);
